import { eq, includes, reject } from 'lodash/fp';

export const togglePresence =
    <T>(item: T) =>
    (collection: T[]): T[] => {
        if (includes(item, collection)) {
            return reject(eq(item), collection);
        }
        return [...collection, item];
    };
